export const createUuid = (): string => {
  const array = new Uint32Array(1);
  // check if browser supports crypto
  if (window.crypto && window.crypto.getRandomValues) {
    window.crypto.getRandomValues(array);
    return array[0].toString(36);
  } else {
    array[0] = Math.floor(Math.random() * Math.pow(2, 32));
  }
  return array[0].toString(36);
};
